import videojs from 'video.js'
import { getTypeFromSource, registerPluginOnce } from '../utils.js'

const Plugin = videojs.getPlugin('plugin')

// Default options for the plugin.
const defaults = {
  theme: {
    name: 'default'
  },
  source: null,
  dvSource: null,
  html5: {
    vhs: {
      withCredentials: false
    }
  }
}

/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */
class NFBAudioDescription extends Plugin {
  /**
   * Create a NFBAudioDescription plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */
  constructor (player, options) {
    // the parent class will add player under this.player
    super(player)
    this.log.level(videojs.log.level())

    this.options = videojs.obj.merge(defaults, options)
    this.button = null
    this.toggleSource = this.toggleSource.bind(this)
    this.dvPlaying = false

    this.player.ready(() => {
      this.init()
    })
  }

  init () {
    this.log('Initializing NFB Audio Description plugin')
    this.addButton()
  }

  addButton () {
    this.button = this.player.controlBar.addChild('button')
    this.button.addClass('vjs-audio-description-button')
    if (this.options.theme.name === 'balmoral-neue') {
      this.button.addClass('nfb-button', 'nfb-button--round-with-icon', 'nfb-button--discreet', '_nfb-button--is-dark')
    }
    this.button.controlText(this.button.localize('Audio Description'))
    this.button.on('click', this.toggleSource)
    this.button.on('tap', this.toggleSource)
  }

  toggleSource () {
    this.log('Toggle source')
    this.dvPlaying = !this.dvPlaying
    this.setState({
      dvPlaying: this.dvPlaying
    })
    const currentTime = this.player.currentTime()
    const isPaused = this.player.paused()
    const source = this.dvPlaying ? this.options.dvSource : this.options.source
    if (this.dvPlaying) {
      this.button.addClass('dv-playing')
    } else {
      this.button.removeClass('dv-playing')
    }

    // Add one time listener to set position to where it was when new source will be loaded
    this.player.one('loadedmetadata', () => {
      // We need to play once even if player was paused to remove "pre play" layout
      this.player.play()
      if (isPaused) {
        this.player.pause()
      }
      this.player.currentTime(currentTime)
      // Kind of hacky (we want to wait for film really playing)
      setTimeout(() => {
        this.player.poster(poster)
      }, 500)
    })

    // remove poster to prevent screen glitch
    const poster = this.player.poster()
    this.player.poster(null)

    // update source
    const sourceType = getTypeFromSource(source)
    switch (sourceType) {
    case 'mp4':
      this.player.src(source)
      this.player.trigger('sourcechanged')
      break

    case 'hls':
      this.player.src({
        src: source,
        type: 'application/x-mpegURL',
        withCredentials: this.options.html5.vhs.withCredentials
      })
      this.player.trigger('sourcechanged')
      break
    }
  }
}

// Define default values for the plugin's `state` object here.
NFBAudioDescription.defaultState = {
  dvPlaying: false
}

// Include the version number.
NFBAudioDescription.VERSION = '1.0.0'

registerPluginOnce(videojs, 'nfbAudioDescription', NFBAudioDescription)

export default NFBAudioDescription
